import React, { useState } from "react";
import {
  FaLock,
  FaUserShield,
  FaSearch,
  FaBug,
  FaChartLine,
  FaCogs,
  FaClipboardCheck,
  FaDatabase,
  FaHandsHelping,
} from "react-icons/fa";
import "../neuroscan.css";
import logo from "../assets/neuroscan/LogoNeuroscan3.png";
import bg from "../assets/neuroscan/worldmap-cyber.jpg";
import Contato from "../components/Contato";

export default function Neuroscan() {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    empresa: "",
    mensagem: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Enviando...");

    try {
      const response = await fetch("https://formspree.io/f/xjkekkdq", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("Mensagem enviada com sucesso!");
        setFormData({
          nome: "",
          email: "",
          telefone: "",
          empresa: "",
          mensagem: "",
        });
      } else {
        setStatus("Ocorreu um erro. Tente novamente.");
      }
    } catch (error) {
      setStatus("Ocorreu um erro. Tente novamente.");
    }
  };

  return (
    <div className="neuroscan-page">
      {/* HERO */}
      <section
        className="neuroscan-hero"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="neuroscan-overlay"></div>
        <img src={logo} alt="Neuroscan Logo" className="neuroscan-logo" />
        <h1 className="neuroscan-title">
          Segurança Autônoma de Última Geração
        </h1>
        <p className="neuroscan-subtitle">
          Detecte, analise e neutralize ameaças em tempo real.
        </p>
      </section>

      {/* SOBRE */}
      <section className="neuroscan-sobre">
        <h2>O que é o Neuroscan?</h2>
        <p>
          O <strong>Neuroscan Professional</strong> é o primeiro software de
          segurança cibernética autônomo do mundo. Ele protege sua rede 24/7, com
          inteligência artificial capaz de agir em segundos contra ameaças
          digitais.
        </p>
      </section>

      {/* FEATURES */}
      <section className="neuroscan-features">
        <div className="neuroscan-card">
          <FaLock size={50} className="icon" />
          <h3>Autenticação e Acesso</h3>
          <p>
            2FA com chave USB, controle granular, auditoria e bloqueio de acessos simultâneos.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaSearch size={50} className="icon" />
          <h3>Coleta Automatizada</h3>
          <p>
            Escaneamento de IPs, portas, domínios e serviços ativos em tempo real.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaBug size={50} className="icon" />
          <h3>Análise de Vulnerabilidades</h3>
          <p>
            Detecção de falhas, classificação por severidade e identificação de zero-days.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaUserShield size={50} className="icon" />
          <h3>Testes de Intrusão</h3>
          <p>
            Simulações de ataques (SQLi, XSS, DDoS), modos Black/Gray/White-box.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaChartLine size={50} className="icon" />
          <h3>Dashboard e Relatórios</h3>
          <p>
            Alertas em tempo real, relatórios validados em blockchain e visualização de cadeias de ataque.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaCogs size={50} className="icon" />
          <h3>SOAR e Automação</h3>
          <p>
            Playbooks automáticos, integração com CVEs e aplicação de patches.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaClipboardCheck size={50} className="icon" />
          <h3>Compliance</h3>
          <p>
            Conformidade com LGPD, ISO 27001, GDPR, relatórios para auditorias e suporte 24/7.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaDatabase size={50} className="icon" />
          <h3>Gestão de Ativos</h3>
          <p>
            Descoberta automática, varredura programada e monitoramento de IoT.
          </p>
        </div>
        <div className="neuroscan-card">
          <FaHandsHelping size={50} className="icon" />
          <h3>Serviços Complementares</h3>
          <p>
            Instalação, consultoria, workshops, equipe especializada e gestão de identidade.
          </p>
        </div>
      </section>

      {/* CONTATO */}
      {/* <section className="neuroscan-contato" id="contato">
        <div className="contato-container">
    <div className="contato-info">
      <h2>Contato</h2>
      <p><strong>Email:</strong> contato@amaratech.com.br</p>
      <p><strong>Telefone:</strong> (21) 3197-0837</p>
      <p><strong>Endereço:</strong><br />
        R. da Assembléia, 10, Sala 1722<br />
        Centro – Rio de Janeiro RJ, 20011-901
      </p>
      <div className="mapa-container">
        <iframe
          title="Mapa Localização"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.9666930676617!2d-43.17847442472421!3d-22.956772840037577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x997fd5c8c0bbfb%3A0xd68999dfadcff0d4!2sR.%20da%20Assembl%C3%A9ia%2C%2010%20-%20Centro%2C%20Rio%20de%20Janeiro%20-%20RJ%2C%2020011-901!5e0!3m2!1spt-BR!2sbr!4v1695571412431!5m2!1spt-BR!2sbr"
          width="100%"
          height="200"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>

    <div className="contato-form">
      <h2>Fale com a gente</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" name="nome" placeholder="Nome" value={formData.nome} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
        <input type="tel" name="telefone" placeholder="Telefone" value={formData.telefone} onChange={handleChange} required />
        <input type="text" name="empresa" placeholder="Empresa" value={formData.empresa} onChange={handleChange} />
        <textarea name="mensagem" placeholder="Mensagem" rows="5" value={formData.mensagem} onChange={handleChange} required></textarea>
        <button type="submit">Enviar</button>
      </form>
      {status && <p style={{ marginTop: '10px', color: '#49e9fe' }}>{status}</p>}
    </div>
  </div>

  <footer className="footer">
    <p>
      Amaratech Soluções em Informática LTDA – 47.165.306/0001-61 © 2025 | Todos os Direitos Reservados.
    </p>
  </footer>
      </section> */}
      <Contato/>
    </div>
  );
}
